import Shader from '../../shader'
import {simpleShader} from '../../util'
import {randomShaderFunc} from '../common'
import * as store from '../../store'

/**
 * @filter         Zoom Blur
 * @description    Blurs the image away from a certain point, which looks like radial motion blur.
 * @param centerX  The x coordinate of the blur origin.
 * @param centerY  The y coordinate of the blur origin.
 * @param strength The strength of the blur. Values in the range 0 to 1 are usually sufficient,
 *                 where 0 doesn't change the image and 1 creates a highly blurred image.
 */
export default function(centerX, centerY, strength) {
  var gl = store.get('gl')
  gl.zoomBlur = gl.zoomBlur || new Shader(null, '\
    uniform sampler2D texture;\
    uniform vec2 center;\
    uniform float strength;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    ' + randomShaderFunc + '\
    void main() {\
      vec4 color = vec4(0.0);\
      float total = 0.0;\
      vec2 toCenter = center - texCoord * texSize;\
      \
      /* randomize the lookup values to hide the fixed number of samples */\
      float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\
      \
      for (float t = 0.0; t <= 40.0; t++) {\
        float percent = (t + offset) / 40.0;\
        float weight = 4.0 * (percent - percent * percent);\
        vec4 sample = texture2D(texture, texCoord + toCenter * percent * strength / texSize);\
        \
        /* switch to pre-multiplied alpha to correctly blur transparent images */\
        sample.rgb *= sample.a;\
        \
        color += sample * weight;\
        total += weight;\
      }\
      \
      gl_FragColor = color / total;\
      \
      /* switch back from pre-multiplied alpha */\
      gl_FragColor.rgb /= gl_FragColor.a + 0.00001;\
    }\
  ');

  simpleShader.call(this, gl.zoomBlur, {
    center: [centerX, centerY],
    strength: strength,
    texSize: [this.width, this.height]
  });

  return this;
}



// WEBPACK FOOTER //
// ./src/filters/blur/zoomblur.js